import { render, staticRenderFns } from "./ModelBox1.vue?vue&type=template&id=596b3428&scoped=true&"
import script from "./ModelBox1.vue?vue&type=script&lang=js&"
export * from "./ModelBox1.vue?vue&type=script&lang=js&"
import style0 from "./ModelBox1.vue?vue&type=style&index=0&id=596b3428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b3428",
  null
  
)

export default component.exports